import { render, staticRenderFns } from "./content.vue?vue&type=template&id=0178f07e&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=0178f07e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178f07e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0178f07e')) {
      api.createRecord('0178f07e', component.options)
    } else {
      api.reload('0178f07e', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=0178f07e&scoped=true", function () {
      api.rerender('0178f07e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productManage/productFrom/content.vue"
export default component.exports